import { render } from "./post.vue?vue&type=template&id=53a8a51f&ts=true"
import script from "./post.vue?vue&type=script&lang=ts"
export * from "./post.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__